import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { Box, type BoxProps } from '../Box/Box';
import { paperRecipe } from './paper.css';

export type PaperProps = Omit<BoxProps, 'backgroundColor'> & {
  elevation?: 0 | 1 | 2 | 3 | 4;
  variant?: 'elevated' | 'outlined';
};

export const Paper = forwardRef<HTMLElement, PaperProps>(
  ({ elevation = 1, variant = 'elevated', className, ...props }, ref) => (
    <Box
      ref={ref}
      className={clsx(paperRecipe({ elevation, variant }), className)}
      {...props}
    />
  ),
);
Paper.displayName = 'Paper';
